import { NgModule } from '@angular/core';
import { TimeToNowPipe } from './time-to-now.pipe';

@NgModule({
  declarations: [TimeToNowPipe],
  imports: [],
  exports: [TimeToNowPipe],
  providers: [TimeToNowPipe],
})
export class TimeToNowModule {}
